export default __webpack_public_path__ + "static/media/pt_gear_logo.508369eb.svg";